import { Text } from "@/components/ui/text";
import { HStack } from "@/components/ui/hstack";
import { Button } from "@/components/ui/button";
import React, {useState} from 'react';
import { useDispatch } from "react-redux";
import i18n from "i18n-js";
import { exporting } from "@/stores/exporting";
import ExportModal from "../modals/ExportModal";
import { IconM } from '@/components/media/IconsV2';

export default function ExportButton({save, flowId, valid, setIsOpen}) {
    const dispatch = useDispatch()
    const [exportSuccess, setExportSuccess] = useState(true)
    const [showModal, setShowModal] = useState(false)

    const onExport = () => {
        console.log('press export')
        const exportResult = dispatch(exporting(save, flowId))
        setExportSuccess(exportResult)
        setShowModal(true)
    }

    const closeModal = () => {
        setShowModal(false)
        setIsOpen(false)
    }

    return (
        <>
            <Button isDisabled={!valid || showModal} onPress={() => onExport()} className="h-[34px] bg-ina-green">
                <HStack space='xs' className="items-center">
                    <IconM className='text-secondary-50' name='smartphone'/>
                    <Text className="text-secondary-50">{i18n.t('studio.flow.export')}</Text>
                </HStack>
            </Button>
            <ExportModal showModal={showModal}  closeModal={closeModal} workflowTitle={save.nodes[0].data.title} success={exportSuccess}/>
        </>
    );
}
